import sensors from "@/api/sensors";

export default {
    state: {
        sensorDataLatest: [],
        sensorDataHistories: []
    },
    mutations: {
        ["RETRIEVE_SENSOR_DATA_LATEST"](state, data) {
            state.sensorDataLatest = data;
        },
        ["RETRIEVE_SENSOR_DATA_HISTORIES"](state, data) {
            state.sensorDataHistories = data;
        },
    },
    actions: {
        async retrieveSensorData(context, params) {
            try {
                params.management_id = await context.dispatch("showManagementID");
                let res = await sensors.showSensorData(params);
                return res.data;
            } catch (error) {
                console.log(error);
            }
        },
        async retrieveSensorDataLatest(context) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID")
                }
                let res = await sensors.showSensorDataLatest(params);
                context.commit("RETRIEVE_SENSOR_DATA_LATEST", res.data.data);
            } catch (error) {
                console.log(error);
            }
        },
        async retrieveSensorDataHistories(context) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID")
                }
                let res = await sensors.showSensorDataHistories(params);
                context.commit("RETRIEVE_SENSOR_DATA_HISTORIES", res.data.histories);
            } catch (error) {
                console.log(error);
            }
        },
    },
    getters: {
        getSensorDataLatest(state) {
            return state.sensorDataLatest;
        },
        getSensorDataHistories(state) {
            return state.sensorDataHistories;
        },
    }
};
